// ConfirmDialog.js — Standard confirmation modal (centered, max 480px).
//
// Built on AppDialog. Cancel is always the secondary button; the confirm
// button is primary blue, or danger red for destructive actions
// (severity="error" or confirmColor="error"). No decorative icons or gradients.
import React from 'react';
import { Typography, Box, CircularProgress } from '@mui/material';
import AppDialog from './shared/AppDialog';
import AppButton from './shared/AppButton';

export default function ConfirmDialog({
  open,
  title = 'Confirm Action',
  message,
  onConfirm,
  onCancel,
  onClose,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  severity = 'warning', // 'warning' | 'error' | 'info' | 'question'
  confirmColor = 'primary',
  loading = false,
}) {
  // Support both onCancel and onClose for flexibility
  const handleCancel = onCancel || onClose;
  const isDanger = severity === 'error' || confirmColor === 'error';

  return (
    <AppDialog
      open={open}
      onClose={loading ? undefined : handleCancel}
      title={title}
      actions={
        loading ? null : (
          <>
            <AppButton variant="secondary" onClick={handleCancel}>
              {cancelText}
            </AppButton>
            <AppButton variant={isDanger ? 'danger' : 'primary'} onClick={onConfirm} autoFocus>
              {confirmText}
            </AppButton>
          </>
        )
      }
    >
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1 }}>
          <CircularProgress size={20} />
          <Typography variant="body2" color="text.secondary">
            {message || 'Loading...'}
          </Typography>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
          {message}
        </Typography>
      )}
    </AppDialog>
  );
}
